import { render } from "./QuickpayOverview.vue?vue&type=template&id=c2746a40&scoped=true"
import script from "./QuickpayOverview.vue?vue&type=script&lang=js"
export * from "./QuickpayOverview.vue?vue&type=script&lang=js"

import "./QuickpayOverview.vue?vue&type=style&index=0&id=c2746a40&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2746a40"]])

export default __exports__